import React from 'react';

import { SelectMenu } from '@reckon-web/select-menu';
import { Text } from '@reckon-web/text';
import { Flex } from '@reckon-web/flex';

export type SortType =
  | 'Due Date (earliest first)'
  | 'Due Date (latest first)'
  | 'Name (A → Z)'
  | 'Name (Z → A)';

const options: SortType[] = [
  'Due Date (earliest first)',
  'Due Date (latest first)',
  'Name (A → Z)',
  'Name (Z → A)',
];

export const Sort: React.FC<{
  sort: SortType;
  testId?: string;
  setSort: (sort: SortType) => void;
}> = ({ sort, setSort, testId }) => (
  <SelectMenu
    data-testid={testId}
    trigger={
      <Flex alignItems="center" gap="small">
        <Text size="small" weight="medium" color="muted" leading="tighter">
          Sort
        </Text>
        {/* sort && <NotificationBadge tone="informative" /> */}
      </Flex>
    }
    options={options}
    itemToLabel={(x) => x}
    itemToValue={(x) => x}
    value={sort}
    onChange={setSort}
  />
);
